import React, { PureComponent } from "react";
import { connect } from "react-redux";
import {
  setCurrentNavPage,
  setSubMenuDirection,
  setSubMenuDirectionToggle
} from "Actions";
import CollaboratorSpace from "./CollaboratorSpace";
import { getURLWithoutHeaderParam } from "Utils";
import { HORIZONTAL, VERTICAL } from "Config";

class CollaboratorSpacePage extends PureComponent {
  constructor(props) {
    super(props);
    let { uen } = this.props.match.params;

    this.state = { organizationUen: uen, withoutHeader: false };
  }

  componentWillMount() {
    const { location } = this.props;
    const { withoutHeader } = getURLWithoutHeaderParam(location);

    this.setState({ withoutHeader: withoutHeader });
  }

  componentDidMount() {
    const { dispatch, subMenuDirection } = this.props;

    dispatch(setCurrentNavPage("COLLABORATOR_SPACE"));

    if (subMenuDirection === VERTICAL) {
      dispatch(setSubMenuDirection(HORIZONTAL));
    }
    dispatch(setSubMenuDirectionToggle(true));

    let { uen } = this.props.match.params;
    this.setState({ organizationUen: uen });
  }

  render() {
    const { withoutHeader } = this.state;
    return (
      <div className={`page-content`} style={{ display: "contents" }}>
        <CollaboratorSpace
          uen={this.state.organizationUen}
          withoutHeader={withoutHeader}
          from={withoutHeader ? "PORTAIL" : null}
        />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  currentOrganization: state.auth.currentOrganization
});

export default connect(mapStateToProps)(CollaboratorSpacePage);



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CollaboratorSpacePage.js